export default __webpack_public_path__ + "static/media/services_watch_arknote@2x.5f6b3597.png";